import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpenDayBanner"] */ "/vercel/path0/src/components/openday/OpenDayBanner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/logos/Brand_SouthAust1_RGB.png");
